module.exports = __webpack_public_path__ + "img/MEDIA088.76578947.jpg";